import React, {  useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import musicposters from '../SanatanDharma/sanatan';
import track1 from '../SanatanSaar/m1.mp3';
import track2 from '../SanatanSaar/m2.mp3';
import track3 from '../SanatanSaar/m3.mp3';
import track4 from '../SanatanSaar/m4.mp3';
import track5 from '../SanatanSaar/m5.mp3';
import track6 from '../SanatanSaar/m6.mp3';


import '../../Zone/zone.css';
import '../../Zone/musicposter.css';

function SaarMusic() {
  const navigate = useNavigate();
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  const tracks = [
    { id: 1, title: 'Sanatan Ki Story.mp3', audio: track1, musicposter:musicposters.poster1},
    { id: 2, title: 'Shanti Se Bhayanak Tak Loka Yatra.mp3', audio: track2, musicposter:musicposters.poster2 },
    { id: 3, title: 'Kalaon Ka Raaz.mp3', audio: track3, musicposter:musicposters.poster3 },
    { id: 4, title: 'Sanskaram Sanskaram.mp3', audio: track4, musicposter:musicposters.poster4 },
    { id: 5, title: 'Sanatan Forever Dakshin Fusion.mp3', audio: track5, musicposter:musicposters.poster5 },
    { id: 6, title: 'सनातन गीत ३० तत्वांची गीता.mp3', audio: track6, musicposter:musicposters.poster6 },
  ];

    useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      const updateTimer = () => setCurrentTime(audio.currentTime);
      const setTrackDuration = () => setDuration(audio.duration);
      audio.addEventListener('timeupdate', updateTimer);
      audio.addEventListener('loadedmetadata', setTrackDuration);

      return () => {
        audio.removeEventListener('timeupdate', updateTimer);
        audio.removeEventListener('loadedmetadata', setTrackDuration);
      };
    }
  }, [selectedTrack]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60) || 0;
    const seconds = Math.floor(time % 60) || 0;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px', color: 'white' }}>
      {!selectedTrack ? (
        <>
          <h1 className="zone-title">🎵 Music Library</h1>
          <div className="episodes-grid">
            {tracks.map((track) => (
              <div key={track.id} className="episode-card" onClick={() => setSelectedTrack(track)}>
                <div className="episode-thumbnail">
                  <img src={track.musicposter} alt={track.title} className="music-poster" />
                  <span className="episode-number">🎶</span>
                  <span className="music-tooltip">{track.title}</span>
                </div>
                <p className="episode-title">{track.title}</p>
              </div>
            ))}
          </div>
          <Link to="/zones" className="back-button">⬅ Back to Museum Realms</Link>
        </>
      ) : (
        <div className="video-player-container">
          <h2>{selectedTrack.title}</h2>
         <audio
            ref={audioRef}
            controls
            autoPlay
            onEnded={() => setSelectedTrack(null)}
            style={{ width: '80%', maxWidth: '600px', margin: '20px 0' }}
            >
            <source src={selectedTrack.audio} type="audio/mp3" />
            Your browser does not support the audio element.
            </audio>

          <p>{formatTime(currentTime)} / {formatTime(duration)}</p>
          <button className="back-button" onClick={() => setSelectedTrack(null)}>⬅ Back to Music</button>
        </div>
      )}
    </div>
  );
}

export default SaarMusic;

